<template>
	<div>
		<header-view pagetype="img"></header-view>
		
		<!-- 分类名 - 总计 -->
		<div class="h-90 flex plr-30 bg-ff">
			<span class="f-32 bold c-11">{{name}}</span>
			<span class="c-33 f-20">共{{total}}幅</span>
		</div>
		
		<div class="section">
			<div class="img-wrapper shou" v-for="item,index in img_list" :key="index" @click="toImgdetail(item.docId,item.doclibId)">
				<img class="img" lazy-load :src="item.COVERPATH" />
				<div class="info">
					<div class="size plr-20 onelist">{{(item.SYS_DOCLIBID==837?'【组图】 ':'')+item.docName}}</div>
				</div>
			</div>
			
			<div v-if="!img_list.length" class="flex-dir-col flex-c list_empty">
				<span class="iconwushuju iconfont f-60 t-c"></span>
				<span class="f-36 c-33 mt-30">该分类下暂未上传图片，请浏览其他分类~</span>
			</div>
		</div>
		
		<div class="bg-f7 flex-c ptb-30" v-if="img_list.length">
			<Page class-name="page-class" :total="total" :page-size="100" @on-change="changePage" />
		</div>
		
		<footer-view></footer-view>
	</div>
</template>

<script>
	import headerView from './specialHeader.vue'
	import footerView from './footer.vue'
	export default {
		data () {
			return {
				cats: '',
				name: '',
				img_list: [],
				totalPages: 0, // 总页数
			}
		},
		
		components: {
			headerView,
			footerView
		},
		
		created() {
			let _this = this
			_this.cats = _this.$route.query.cats
			_this.name = _this.$route.query.name
			document.title=_this.$route.query.name
			
			_this.bindimgs()
			
		},
		
		methods: {
			async bindimgs (page=0) {
				 let _this = this
				 _this.$Spin.show()
				 let data = {}
				 data.cats = _this.cats
				 data.size = 100
				 data.page = page
				 // data.t = 25
				 data.sld = "AHSCXB"
				 data.sort = "SYS_LASTMODIFIED_dt,desc"
				 const res = await _this.get_res('/search',data)
				 _this.img_list = res.content
				 _this.totalPages = res.totalPages
				 _this.total = res.totalElements
				 _this.$Spin.hide()
			},
			
			// 改变分页
			changePage (e) {
				this.bindimgs(e-1)
			},
			
			// 跳转到图片详情
			toImgdetail (id,tid) {
				// this.$router.push({path: '/img_detail', query: {id,tid}})
				
				let link = this.$router.resolve({
					path:'/specialimg_detail',
					query:{ id,tid }
				});
				window.open(link.href, "_blank"); //打开新窗口
			}
		},
		
		// 监听器监听路由的变化
		watch: {
			'$route'(to,from) {
				let _this = this
				_this.cats = _this.$route.query.cats
				_this.name = _this.$route.query.name
				// 做一些路由变化的响应
				this.bindimgs(0)
			}
		},
		
		beforeDestroy () {
			document.title= '图片安徽'
		},
	}
</script>

<style lang="less" >
.ivu-page-item-active {
	border-color: #2d8cf0;
	color: #fff;
	background-color: #2d8cf0;
}
.ivu-page-item-active a {
	color: #fff!important;
}
.section {
	  display: flex;
	  flex-wrap: wrap;
	  padding: 25px 45px;
		background-color: #f7f7f7;
	  .img-wrapper {
	    flex-grow: 1;
	    margin: 5px;
	    position: relative;
	    overflow: hidden;
	    height: 210px;
	    .img {
	      height: 100%;
	      background-size: cover;
	      background-position: center;
	    }
			img {
			  opacity: 1;
			  min-width: 100%;
			  height: 210px;
			}
	    .info {
	      position: absolute;
	      bottom: 0px;
	      color: #ffffff;
	      left: 0;
	      right: 0;
	      background-color: rgba(0, 0, 0, 0.3);
	      line-height: 44px;
	      height: 0px;
	    }
	   
	  }
		.img-wrapper:hover .info {
			height: 44px;
			transition: all 0.5s;
	  }
}

.section&::after {
		content: "";
		flex-grow: 99999;
	}
	
	// 空状态列表
	.list_empty {
		width: 100%;
		.iconwushuju {
			font-size: 200px;
		}
	}
</style>
